import React, { useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import "./Properties.css"; // Import your custom CSS if necessary

const Properties = () => {
  // Dev listing IDs - duplicated for testing purposes
  const listingIds = [
    "903237251548605525", //501 - 128 Waterfront Court SW
    // "1045988710251209191", //35 Cornerstone Ave NE
    "1046449173694868148", //1725 32 Ave SW
    // "1079237711511536477", //58 Chapalina Green SE
    "1123568768223510803", //291 Lucas Blvd NW - Upper
    // "1123600481346707425", //291 Lucas Blvd NW - Lower
    // "1125457094697996209", //121 Cortina Bay SW
    // "1108293768278134482", //75 Nolanfield Terrace NW
    "697151385221238226", //1606 - 135 13 Ave SW
    "1124350663233023458", //206 Cityside Grove NE
    "1152243113654806555", //109 - 10060 46 St NE
    "1148595170085534998", //62 Carrington Rise NW
    // "1328637285882489425", //1620 2A St NW
    "1154732645722813009", //85 Tuscarora Heights NW
    "1255089656088503846", //146 Edith Green NW
    "1286593241479548145", //412 Tekarra Dr NW
    // "1326278322240507400", //1620 2A St NW - Upper
    "1332283304781820185", //16 Coverdale Road NE - Lower
    // "1425377184690400473", //#401 683 10 St SW
    "1436647070544886189", //251 Lucas Blvd NW
    "1439192697558541093", //727 Creekstone Cir SW
    // "1441477088885124130", //5004 2nd St NW
    "1441514190738790452", //111 Panorama Hills Way NW
    // "1465251103631689661", //#511 - 450 8 Ave SE
    // "1214898836367584777", //1620 2A St NW
  ];

  const scriptLoadedRef = useRef(false);

  // Load Airbnb embed script after component mounts
  useEffect(() => {
    // Only load the script once
    if (!scriptLoadedRef.current) {
      const script = document.createElement("script");
      script.src = "https://www.airbnb.ca/embeddable/airbnb_jssdk";
      script.async = true;
      document.body.appendChild(script);
      scriptLoadedRef.current = true;
    }
  }, []);

  const settings = {
    // dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    pauseOnHover: true,

    // responsive: [
    //   {
    //     breakpoint: 1024,
    //     settings: {
    //       slidesToShow: 2,
    //       slidesToScroll: 1,
    //     },
    //   },
    //   {
    //     breakpoint: 600,
    //     settings: {
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //     },
    //   },
    // ],
  };

  return (
    <section className="py-16 bg-gray-100" id="properties">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold mb-10 text-center">
          Check Out Our Properties
        </h2>
        <div className="max-w-7xl mx-auto">
          <Slider {...settings}>
            {listingIds.map((listingId, index) => (
              <div key={index} className="px-1.5">
                <div
                  className="airbnb-embed-frame bg-white rounded-lg shadow-md overflow-hidden"
                  data-id={listingId}
                  data-view="home"
                  data-hide-price="true"
                  style={{ width: "100%", height: "360px", margin: "auto" }}
                >
                  <a
                    href={`https://www.airbnb.ca/rooms/${listingId}?guests=1&adults=1&s=66&source=embed_widget`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View On Airbnb
                  </a>
                  <a
                    href={`https://www.airbnb.ca/rooms/${listingId}?guests=1&adults=1&s=66&source=embed_widget`}
                    rel="nofollow"
                    target="_blank"
                  >
                    Rental unit in Calgary · ★5.0 · 3 bedrooms · 3 beds · 2.5
                    baths
                  </a>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Properties;
